import React, { Component } from 'react';
import EWH from '../components/EWH';
//import { Link } from 'react-router-dom';
//import { Form } from 'react-bootstrap';
export class HomeComunali2026B extends Component {
  render() {
    return (
    <div className="App">
        <EWH id="ewh-fascione-hp-comunali" repo='/elezioni/withub/comunali-2026/comunali-ballottaggio/fascione-composto.html?cid=ewh-fascione-hp-comunali&amp;url=https%3A%2F%2Fmediaset.withub.it%2F' />
        <EWH id="ewh-regioni-hp-comunali" repo='/elezioni/withub/comunali-2026/comunali-ballottaggio/regioni.html?cid=ewh-regioni-hp-comunali&amp;url=https%3A%2F%2Fmediaset.withub.it%2F' />
    </div>
    )
  }
}

export default HomeComunali2026B
